export default {

	data() {
		return {
			scrollDistance: 30
		}
	},

	mounted() {
		window.addEventListener('keyup', this.handleKeyUp)
		window.addEventListener('keydown', this.handleKeyDown)
	},

	destroyed() {
		window.removeEventListener('keyup', this.handleKeyUp)
		window.removeEventListener('keydown', this.handleKeyDown)
	},

	methods: {
		/* 切换上一章下一章 */
		handleKeyUp(e) {
			switch (e.key) {
				case 'ArrowRight':
					this.nextContent()
					break;
				case 'ArrowLeft':
					this.preContent()
					break;
			}
		},

		/* 上滑/下滑 */
		handleKeyDown(e) {
			switch (e.key) {
				case 'ArrowUp':
					this.scrollToTop()
					break;
				case 'ArrowDown':
					this.scrollToBottom()
					break;
			}
		},

		scrollToTop() {
			let dom = this.$refs.htmlWrapper
			if (dom.scrollTop > 0) {
				dom.scrollTop -= this.scrollDistance
			}
		},

		scrollToBottom() {
			let dom = this.$refs.htmlWrapper
			if (Math.ceil(dom.scrollTop + dom.offsetHeight) < dom.scrollHeight) {
				dom.scrollTop += this.scrollDistance
			}
		}
	}
}